export const RootTopicId = "null";
export const RootTopicFolder = {
  title: "studyCenter",
  titleEditor: "editorCenter",
  type: "folder",
  id: RootTopicId,
};
export const SubscriptionTopicId = "6d6f3cc9-4466-4542-8787-3a6d43c0a4bc";

export const SubscriptionTopicFolder = {
  title: "favoriteSubscription",
  label: "favoriteSubscription",
  type: "folder",
  id: SubscriptionTopicId,
};

export const SystemFolderIds = [RootTopicFolder.id, SubscriptionTopicFolder.id];

export const STORAGE_KEY_LAST_SC_ACTIONS = "lastScActions";

export const UnderlineColor = "00000000-0000-0000-0000-000000000000";

export const UserRoles = {
  studyCenterEditor: "StudyCenterEditor",
  StudyCenterEditorAdmin: "StudyCenterEditorAdmin",
};
